<template>
  <!-- The slug resolved to no listing (bad/expired/deleted link) — show the
       standard 404 page rather than the listing markup rendered from an empty
       object, which came out as a shell reading "Invalid Date" and zeroes. -->
  <NotFound v-if="notFound" />

  <!-- Hold the frame until the lookup settles, or that same empty shell
       flashes on screen before the 404 lands. -->
  <div v-else-if="loadingPost" class="navbar">
    <Navigation />
    <div class="post-loading">
      <PulseLoader size="16px" color="var(--color-primary)" />
    </div>
  </div>

  <div v-else class="navbar">
    <Navigation />
    <div class="main-container">
      <div class="content-wrapper">
        <div class="back-row">
          <button class="back-btn" @click="goBack">
            <img src="../icons/Icons (3).svg" alt="Back" />
            Back
          </button>
        </div>
      </div>
      <div class="container-body">
        <div class="left-container">
          <div class="top-section">
            <div class="top-section-body">
              <div>
                <span class="header-text" v-if="shouldShowField('title')">{{ service.servicesName }}</span>
                <div class="additional-content">
                  <span class="eye">
                    <img src="../icons/Frame 38 (5).svg" alt="Date posted" />
                    <span class="eye-text">{{
                      formatDate(service.createdTime)
                    }}</span>
                  </span>

                  <span class="eye">
                    <img src="../icons/Frame 38 (2).svg" alt="View count" />
                    <span class="eye-text">{{ service.viewCount }}</span>
                  </span>

                  <span class="eye">
                    <img src="../icons/Frame 38 (3).svg" alt="Contact count" />
                    <span class="eye-text">0</span>
                  </span>
                </div>

                <div class="location" v-if="shouldShowField('location')">
                  <span class="locImage">
                    <img src="../icons/Frame 38 (4).svg" alt="Location" />
                  </span>
                  <span class="location-data"
                    ><p>{{ service.location }}</p></span
                  >
                </div>
                <div class="top-right">
                  <div class="right-button">
                    <button class="button-width">
                      <p>{{ service.serviceType1 || "Services" }}</p>
                    </button>
                    <span class="share-view" @click="showShare = true">
                      <img src="../icons/Actions.svg" alt="Share options" />
                    </span>
                    <span class="share-view" @click.stop="copyLink(service)">
                      <img
                        src="../icons/icons8-external-link (2).svg"
                        alt="Copy link"
                      />
                    </span>
                  </div>
                </div>
              </div>
              <div class="box-view-body">
                <div class="first-box">
                  <span class="first-content"  v-if="shouldShowField('serviceType1')">
                    <p>{{ service.serviceType2 || "Services" }}</p>
                    <div class="first-subtext" v-if="shouldShowField('serviceType2')">
                      <p>{{ service.serviceType1 || "Services" }}</p>
                    </div>
                  </span>
                </div>
                <div class="second-box">
                  <span class="second-content">
                    <p>{{ service.viewCount }}</p>
                    <div class="second-subtext">
                      <p>Views</p>
                    </div>
                  </span>
                </div>

                <div class="third-box">
                  <span class="third-content">
                    <p>0</p>
                    <div class="third-subtext">
                      <p>Contacted</p>
                    </div>
                  </span>
                </div>

                <div class="fourth-box">
                  <span class="fourth-content">
                    <p>0</p>
                    <div class="fourth-subtext">
                      <p>--</p>
                    </div>
                  </span>
                </div>
              </div>
              <div class="images-box" v-if="shouldShowField('images') && uploadedimages.length > 0">
                <div class="image-header">
                  <p class="active">Photos</p>
                  <!-- <p>Amenities</p> -->
                </div>

                <div class="images-section">
                  <div
                    class="addImages"
                    v-for="(img, index) in visibleImages"
                    :key="index"
                    @click="openLightbox(index)"
                  >
                    <img :src="img" alt="Uploaded image" />
                  </div>
                 <teleport to="body">
  <div
    v-if="lightboxIndex !== null"
    class="lightbox d-flex justify-content-center align-items-center"
    @click.self="closeLightbox"
    @touchstart="onTouchStart"
    @touchend="onTouchEnd"
  >
    <span class="close-btn-image" @click.stop="closeLightbox">
      <i class="fas fa-times"></i>
    </span>
    <button
      v-if="uploadedimages.length > 1"
      class="lightbox-nav lightbox-prev"
      @click.stop="prevImage"
      aria-label="Previous image"
    >
      <i class="fas fa-chevron-left"></i>
    </button>
    <div class="lightbox-content position-relative" @click.stop>
      <img :src="uploadedimages[lightboxIndex]" alt="Lightbox Image" class="img-fluid shadow-lg rounded" />
    </div>
    <button
      v-if="uploadedimages.length > 1"
      class="lightbox-nav lightbox-next"
      @click.stop="nextImage"
      aria-label="Next image"
    >
      <i class="fas fa-chevron-right"></i>
    </button>
    <div v-if="uploadedimages.length > 1" class="lightbox-counter">
      {{ lightboxIndex + 1 }} / {{ uploadedimages.length }}
    </div>
  </div>
</teleport>
                </div>
                <div class="show-more-images" v-if="uploadedimages.length > initialImageCount">
                  <button type="button" class="show-more-btn" @click="showAllImages = !showAllImages">
                    <span v-if="!showAllImages">Show More ({{ hiddenImageCount }} more)</span>
                    <span v-else>Show Less</span>
                    <i :class="showAllImages ? 'fas fa-chevron-up' : 'fas fa-chevron-down'"></i>
                  </button>
                </div>
              </div>
              <!-- ══ Description Section ══ -->
              <div class="desc-section" v-if="shouldShowField('description')">
                <!-- Movies (serviceType2 === 'Movies'): render the crawled
                     "Location:" / "Show Timings:" blob as a structured card. -->
                <div v-if="movieSchedule" class="movie-detail">
                  <div v-if="movieSchedule.synopsis.length" class="movie-synopsis">
                    <p
                      v-for="(line, si) in movieSchedule.synopsis"
                      :key="'syn' + si"
                    >{{ line }}</p>
                  </div>

                  <p v-if="movieSchedule.note" class="movie-note">
                    <i class="fas fa-circle-info"></i> {{ movieSchedule.note }}
                  </p>

                  <h4 class="movie-showtimes-title">
                    <i class="fas fa-clock"></i> Show Timings
                  </h4>

                  <div
                    v-for="(v, vi) in movieSchedule.venues"
                    :key="'venue' + vi"
                    class="movie-venue-block"
                  >
                    <div v-if="v.name" class="movie-venue">
                      <i class="fas fa-location-dot"></i>
                      <div class="movie-venue-text">
                        <strong>{{ v.name }}</strong>
                        <span v-if="v.address">{{ v.address }}</span>
                      </div>
                    </div>

                    <div class="movie-showtable">
                      <div
                        v-for="(s, i) in v.shows"
                        :key="i"
                        class="movie-showrow"
                      >
                        <div class="movie-showdate">{{ s.date }}</div>
                        <div class="movie-showchips">
                          <span v-if="!s.times.length" class="movie-chip movie-chip--tba">TBA</span>
                          <span
                            v-for="(t, ti) in s.times"
                            :key="ti"
                            class="movie-chip"
                          >{{ t }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-else class="desc-contents">{{ originalDescription }}</div>

              </div>
            </div>
          </div>
        </div>
        <div
          v-if="showShare"
          class="share-overlay"
          @click.self="showShare = false"
        >
          <div class="share-box">
            <button class="close-btn" @click="showShare = false">×</button>
            <h3>Share this Post</h3>

            <div class="share-options">
              <div class="share-item" @click.stop="shareWhatsApp()">
                <i class="fab fa-whatsapp"></i>
                <span>WhatsApp</span>
              </div>
              <div class="share-item" @click.stop="shareTwitter()">
                <i class="fab fa-twitter"></i>
                <span>Twitter (X)</span>
              </div>
              <div class="share-item" @click.stop="shareFacebook()">
                <i class="fab fa-facebook-f"></i>
                <span>Facebook</span>
              </div>
              <div class="share-item" @click.stop="shareEmail()">
                <i class="fas fa-envelope"></i>
                <span>Email</span>
              </div>
              <div class="share-item" @click.stop="shareInstagram()">
                <i class="fab fa-instagram"></i>
                <span>Instagram</span>
              </div>
              <div class="share-item" @click.stop="copyLink()">
                <i class="fas fa-link"></i>
                <span>Copy Link</span>
              </div>
            </div>
          </div>
        </div>


        <ViewAdsRight
          v-if="service && Object.keys(service).length"
          :service="service"
        />
      </div>
      <FooterSection />
    </div>
  </div>
</template>
<script>
import Navigation from "./Navigation.vue";
import { WEB_ORIGIN } from "@/config/apiBase";
import ViewAdsRight from "./ViewAdsRight.vue";
import FooterSection from "./footer.vue";
import NotFound from "./NotFound.vue";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import axios from "axios";
import { UAParser } from "ua-parser-js";
import { toast } from "vue-sonner";
import { EventBus } from "../../services/EventBus.js";
import { trackEvent } from "@/composables/useAnalytics";
import {
  loadServiceTypesMap,
  buildFieldVisibility,
  isFieldVisible,
} from "@/utils/fieldVisibility";
import { canonicalSlug } from "@/utils/slug";
export default {
  components: {
    Navigation,
    ViewAdsRight,
    FooterSection,
    NotFound,
    PulseLoader,
  },
  data() {
    return {
      // Set once the slug is known not to resolve to a listing — swaps the
      // whole page for the 404 view.
      notFound: false,
      loadingPost: true,
      servicesID: null,
      userID: null,
    serviceName:"",
      from: "",
      uploadedimages: [],
      showAllImages: false,
      initialImageCount: 4,
      service: {},
      lightboxIndex: null,
      touchStartX: 0,
      touchStartY: 0,
      showShare: false,
      shareUrl: window.location.href,
      servicetypes2Map: {},
      fieldVisibility: {},
    };
  },

mounted: async function () {
  window.addEventListener("keydown", this.onLightboxKeydown);
  try {
    window.scrollTo(0, 0);
    await this.servicetype();
    const { serviceName } = this.$route.params;
    this.serviceName = serviceName;

const path = window.location.pathname;

// The pathname keeps percent-encoding (admin links encode the slug, so a
// "+N" uniqueness suffix arrives as %2B). Decode before the DB lookup,
// which stores the raw slug.
let slug = path.replace('/view-post/', '');
try { slug = decodeURIComponent(slug); } catch (e) { /* malformed % — keep raw */ }

// A bare /view-post/ carries no listing to show. Guard it here: the lookup
// treats an empty url as "no filter" and hands back the first page of the
// collection, so the page would render an arbitrary stranger's listing.
if (!slug.trim()) {
  this.notFound = true;
  return;
}

let context = JSON.parse(localStorage.getItem("viewPostContext") || "{}");

// ✅ FIXED: always compare
if (context.url !== slug) {
  localStorage.removeItem("viewPostContext");
  context = {};
}

console.log("context data", context);

// ✅ FIXED: strict validation
if (context.url === slug && context.servicesID && context.userID) {
  this.servicesID = context.servicesID;
  this.userID = context.userID;
  this.from = context.from || "";

  console.log("Using data from localStorage");
} else {
  console.log("Fetching view ads data from API ...");

  const res = await axios.post("/api/serviceslinklist", { url: slug });
  const response = res?.data?.items || [];

  if (response.length && response[0].serviceID && response[0].userID) {
    this.servicesID = response[0].serviceID;
    this.userID = response[0].userID;

    localStorage.setItem(
      "viewPostContext",
      JSON.stringify({
        servicesID: this.servicesID,
        userID: this.userID,
        from: this.from || "",
        url: slug,
      })
    );
  } else {
    this.servicesID = null;
    this.userID = null;
    console.log("Ad link not found or invalid.");
    this.notFound = true;
    return;
  }
}

    // Track visitor ONLY after IDs exist
    if (this.servicesID && this.userID) {
      this.trackVisitor();
    }

    // Fetch service basic info
    const customResponse = await axios.post("/api/servicescustom", {
      servicesID: this.servicesID,
    });
    const items = customResponse?.data?.items || [];

    // The link row survived but its listing is gone — same dead end for the
    // reader, so treat it as a 404 too rather than rendering an empty shell.
    if (!items.length || !items[0]?.servicesID) {
      this.notFound = true;
      return;
    }

    this.service = items[0];

    // Set field visibility after service is loaded
    this.setFieldVisibilityForView();

    trackEvent('view_post', {
      post_id: this.servicesID,
      category: this.service.serviceType1 || '',
      sub_type: this.service.serviceType2 || '',
    });

    const serviceImages = this.service.serviceImages || [];
    const activeFilepaths = serviceImages
      .filter(img => img.isActive === "true")
      .map(img => img.filepath);
    this.uploadedimages = [];
    for (const filePath of activeFilepaths) {
      const fileRes = await axios.post(
        "/api/file/get",
        { fileName: filePath, albumName: "default" },
        { responseType: "blob" }
      );
      const blob = new Blob([fileRes.data], {
        type: fileRes.headers["content-type"] || "image/jpeg",
      });
      this.uploadedimages.push(URL.createObjectURL(blob));
    }
  } catch (error) {
    console.error("Failed to load View Ads page:", error);
    // Only when nothing was loaded at all. A failure after the listing is on
    // screen (an image blob, say) must not replace a good page with a 404.
    if (!this.service || !this.service.servicesID) {
      this.notFound = true;
    }
  } finally {
    this.loadingPost = false;
  }
},

beforeUnmount() {
  window.removeEventListener("keydown", this.onLightboxKeydown);
  document.body.style.overflowY = "auto";
},

  computed: {
    visibleImages() {
      if (this.showAllImages) return this.uploadedimages;
      return this.uploadedimages.slice(0, this.initialImageCount);
    },
    hiddenImageCount() {
      return Math.max(0, this.uploadedimages.length - this.initialImageCount);
    },
    // The description is rendered verbatim (see the .desc-contents rule): the
    // author's own line breaks are the formatting. Only normalise CRLF and trim
    // the blank lines at either end, which would otherwise show as a gap.
    originalDescription() {
      return (this.service.Description || '')
        .replace(/\r\n/g, '\n')
        .replace(/^\s*\n+|\n+\s*$/g, '');
    },

    // Structured view for movie listings (Events → Movies). The crawled
    // description is a flat blob with TAB-separated "<date>\t<time>\t<time>"
    // showtime rows that the generic formatter would flatten into an
    // unreadable line. Two crawled shapes exist:
    //   1. A single "Location:" + "Show Timings:" block (one venue).
    //   2. Several theatre blocks — "<theatre name>" header followed by date
    //      rows, blocks separated by "+++++" lines (many venues).
    // This parser handles both, keeps the raw tabs, and returns a synopsis,
    // an optional note, and a list of venues each with its own showtimes.
    // Returns null for anything that isn't a movie with parseable showtimes,
    // so every other listing keeps the normal formatted description.
    movieSchedule() {
      if ((this.service.serviceType2 || '') !== 'Movies') return null;
      const raw = (this.service.Description || '').replace(/\r\n/g, '\n');
      if (!raw.trim()) return null;

      const isJunk = (l) => /^[+*_=~-]{3,}$/.test(l.trim());
      const isMarker = (l) =>
        /^\s*(location|show\s*timings?|showtimes?|timings?)\s*:?\s*$/i.test(l);
      const isNote = (l) => /subject to change|check back|latest updates/i.test(l);
      const isDateRow = (l) =>
        /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)\s+\d{1,2}\b/i.test(l.trim());

      const parseRow = (line) => {
        let cells = line.split(/\t+/).map((c) => c.trim()).filter(Boolean);
        if (cells.length === 1) {
          // No tabs survived — fall back to splitting on runs of spaces.
          cells = line.trim().split(/\s{2,}/).map((c) => c.trim()).filter(Boolean);
        }
        const date = cells[0] || '';
        const times = cells.slice(1).filter((c) => /\d/.test(c));
        return { date, times };
      };

      const introLines = [];
      const noteLines = [];
      const venues = [];
      let cur = null; // current venue collecting show rows
      let pendingHeader = []; // text lines that will name the next venue
      let introDone = false;

      for (const line of raw.split('\n')) {
        const t = line.trim();

        if (isJunk(t)) { cur = null; pendingHeader = []; continue; }
        if (t === '') { if (introLines.length) introDone = true; pendingHeader = []; continue; }
        if (isMarker(t)) { introDone = true; continue; }
        if (isNote(t)) { noteLines.push(t); continue; }

        if (isDateRow(t)) {
          introDone = true;
          if (!cur) {
            cur = {
              name: pendingHeader[0] || '',
              address: pendingHeader.slice(1).join(', '),
              shows: [],
            };
            venues.push(cur);
            pendingHeader = [];
          }
          cur.shows.push(parseRow(line));
          continue;
        }

        // Plain text line: intro/synopsis until the first venue starts, then
        // it names the next venue.
        if (!introDone) { introLines.push(t); continue; }
        pendingHeader.push(t);
        cur = null; // a fresh header → the next date row starts a new venue
      }

      const withShows = venues.filter((v) => v.shows.length);
      if (!withShows.length) return null;

      return {
        synopsis: introLines,
        note: noteLines.join(' '),
        venues: withShows,
      };
    },

    // ── All raw bullets: handles both \n-separated and " -" flat formats
    _rawBullets() {
      const raw = this.service.Description || '';
      // Try emoji 🏠 Description section first
      const section = raw.match(/🏠\s+Description\s*\n+([\s\S]*?)(?:\n✨|\n👤|\nℹ️|$)/)?.[1]?.trim() || raw;
      let lines = section.split(/\n+/).map(l => l.trim()).filter(Boolean);
      // If all text is on 1-2 lines (flat blob with " -" separators), split on them
      if (lines.length <= 2) {
        const combined = lines.join(' ');
        const parts = combined.split(/ -(?=[A-Za-z0-9])/).map(l => l.trim()).filter(Boolean);
        if (parts.length > 2) lines = parts;
      }
      return lines.map(l => l.replace(/^[-–•]+\s*/, '').trim()).filter(l => l.length > 1);
    },

    // Title for the desc card — first bullet if short, else servicesName
    descCardTitle() {
      const bullets = this._rawBullets;
      if (bullets.length > 0 && bullets[0].length < 80) return bullets[0];
      const name = this.service.servicesName || '';
      return name.length <= 80 ? name : name.substring(0, 77) + '…';
    },

    // Subtitle for the desc card — second bullet if it looks like a place name
    descCardSubtitle() {
      const bullets = this._rawBullets;
      if (bullets.length > 1) {
        const second = bullets[1];
        // A place name is short and doesn't start with a preposition/verb phrase
        if (second.length < 60 && !/^(on |to |at |in |for |and |the |from |walking|behind|near)/i.test(second)) {
          const city = this.service.city || '';
          return city ? `${second}, ${city}` : second;
        }
      }
      return this.service.location || this.service.city || '';
    },

    // Property grid: try emoji template first, fall back to raw bullet parsing
    propertyGridItems() {
      const raw = this.service.Description || '';
      const items = [];

      // Emoji-formatted template
      const propMatch = raw.match(/🛏️\s+Property Details\s*\n([\s\S]*?)(?:\n\n|🏠|✨|ℹ️|👤|💰|📅|$)/);
      if (propMatch) {
        for (const line of propMatch[1].split('\n')) {
          const m = line.match(/^([^:]+):\s*(.+)$/);
          if (!m) continue;
          const key = m[1].trim().toLowerCase();
          const val = m[2].trim();
          if (!val || key === 'posted by') continue;
          if (key === 'room type')             items.push({ label: 'Room Type',       value: val, icon: 'fas fa-door-open' });
          else if (key === 'preferred gender') items.push({ label: 'Preferred Gender', value: val, icon: 'fas fa-venus-mars' });
          else if (key === 'bathroom')         items.push({ label: 'Bathroom',         value: val, icon: 'fas fa-bath' });
          else if (key === 'stay type')        items.push({ label: 'Stay Type',        value: val, icon: 'fas fa-clock' });
          else if (key === 'accommodation')    items.push({ label: 'Accommodates',     value: val, icon: 'fas fa-user' });
          else if (key === 'deposit')          items.push({ label: 'Deposit',          value: val, icon: 'fas fa-hand-holding-usd' });
        }
        const availMatch = raw.match(/📅\s+Availability:\s*\n(From [^\n]+)/);
        if (availMatch) items.push({ label: 'Move in From', value: availMatch[1].replace(/^From\s+/i, '').trim(), icon: 'fas fa-calendar-alt' });
        const rentMatch = raw.match(/💰\s+Rent:\s*\n([^\n]+)/);
        if (rentMatch) items.push({ label: 'Expected Rent', value: rentMatch[1].trim(), icon: 'fas fa-dollar-sign' });
        if (this.service.serviceTitle) items.unshift({ label: 'Ad Type', value: this.service.serviceType2, icon: 'fas fa-tag' });
        if (items.length > 1) return items;
      }

      // Fallback: parse from raw bullet lines
      const propLines = this._rawBullets.filter(l => this._isPropertyLine(l));
      for (const line of propLines) {
        const parsed = this._parsePropertyBullet(line);
        if (parsed) parsed.forEach(p => items.push(p));
      }
      return items;
    },

    // Clean description text (emoji format) — not used directly but kept for fallback
    cleanDescription() {
      const raw = this.service.Description || '';
      const match = raw.match(/🏠\s+Description\s*\n+([\s\S]*?)(?:\n✨|\n👤|\nℹ️|$)/);
      if (match) return match[1].trim();
      return raw;
    },

    // Bullets to display: skip title, subtitle, property lines, rule lines, contact lines
    descriptionBullets() {
      const bullets = this._rawBullets;
      if (!bullets.length) return [];
      const hasEmojiFormat = /🏠/.test(this.service.Description || '');
      if (hasEmojiFormat) {
        return (this.cleanDescription || '').split(/\n+/).map(l => l.trim()).filter(Boolean);
      }
      // Raw format: skip first 2 (title + subtitle), skip property/rule/contact lines
      return bullets.slice(2).filter(l =>
        !this._isRuleLine(l) &&
        !this._isPropertyLine(l) &&
        !this._isContactLine(l)
      );
    },

    // Amenity/rule tags: emoji format first, then fallback to rule lines in raw bullets
    amenityTags() {
      const raw = this.service.Description || '';
      const match = raw.match(/✨\s+Amenities\s*\n([\s\S]*?)(?:\n\n|👤|ℹ️|$)/);
      if (match) return match[1].split('\n').map(l => l.trim()).filter(Boolean);
      return this._rawBullets.filter(l => this._isRuleLine(l));
    },

    roommatePreferenceItems() {
      const raw = this.service.Description || '';
      const match = raw.match(/👤\s+Roommate Preferences\s*\n([\s\S]*?)(?:\n\n|$)/);
      if (!match) return [];
      return match[1].split('\n').map(l => l.trim()).filter(Boolean);
    },
  },

  methods: {
    // ── Raw bullet helpers ──
    _isRuleLine(line) {
      return /\b(no |not |allowed|prohibited|included in the rent|pets?|smoking|partying)\b/i.test(line);
    },
    _isPropertyLine(line) {
      return /\b(bedroom|bath|bathroom|heat|electric|gas|finished room|upstairs|basement)\b/i.test(line);
    },
    _isContactLine(line) {
      return /\b(call|phone|contact|zero|\d{3}[-.]\d{3})\b/i.test(line);
    },
    _parsePropertyBullet(line) {
      const l = line.toLowerCase();
      const results = [];
      // "Two bedrooms upstairs"
      const bedroomM = l.match(/(\w+)\s+bedroom/);
      if (bedroomM) {
        const nw = { one:1, two:2, three:3, four:4, five:5, six:6 };
        const n = nw[bedroomM[1]] || parseInt(bedroomM[1]) || bedroomM[1];
        const sub = /upstairs/.test(l) ? 'Upstairs' : /basement/.test(l) ? 'In the Basement' : '';
        results.push({ value: `${n} Bedroom${n !== 1 ? 's' : ''}`, subLabel: sub, icon: 'fas fa-bed', label: 'Bedrooms' });
      }
      // "a finished room in the basement"
      if (/finished room/.test(l)) {
        const sub = /basement/.test(l) ? 'In the Basement' : /upstairs/.test(l) ? 'Upstairs' : '';
        results.push({ value: '1 Finished Room', subLabel: sub, icon: 'fas fa-couch', label: 'Finished Room' });
      }
      // "One-and-a-half bath" / "1.5 bath"
      if (/bath/.test(l) && !bedroomM) {
        let n = '1';
        if (/one.and.a.half|1\.5/.test(l)) n = '1.5';
        else if (/two/.test(l)) n = '2';
        else if (/half/.test(l)) n = '0.5';
        else { const dm = l.match(/([\d.]+)\s*bath/); if (dm) n = dm[1]; }
        results.push({ value: `${n} Bathroom`, subLabel: '', icon: 'fas fa-bath', label: 'Bathroom' });
      }
      // "Heat is Electric"
      const heatM = l.match(/heat\s+is\s+(\w+)/);
      if (heatM) {
        const type = heatM[1].charAt(0).toUpperCase() + heatM[1].slice(1);
        results.push({ value: 'Heat', subLabel: type, icon: 'fas fa-bolt', label: 'Heat' });
      }
      return results.length ? results : null;
    },

    // Icon for each description bullet line
    getBulletIcon(text) {
      const t = (text || '').toLowerCase();
      if (/bus|transit|train|metro|commut/.test(t)) return 'fas fa-bus';
      if (/mall|shop|store|market|grocery/.test(t)) return 'fas fa-shopping-bag';
      if (/walk|pedestrian|distance/.test(t)) return 'fas fa-walking';
      if (/school|university|college|campus/.test(t)) return 'fas fa-graduation-cap';
      if (/park|gym|recreation|restaurant|theater/.test(t)) return 'fas fa-map-marker-alt';
      if (/bedroom|room|basement|upstairs/.test(t)) return 'fas fa-bed';
      if (/bath/.test(t)) return 'fas fa-bath';
      if (/heat|electric|gas|utility|utilities/.test(t)) return 'fas fa-bolt';
      return 'fas fa-circle';
    },
    // Icon for each rule/amenity tag
    getRuleIcon(tag) {
      const t = (tag || '').toLowerCase();
      if (/smok/.test(t)) return 'fas fa-smoking-ban';
      if (/pet|dog|cat/.test(t)) return 'fas fa-paw';
      if (/party|parties|event/.test(t)) return 'fas fa-ban';
      if (/util|electric|gas|water|included/.test(t)) return 'fas fa-dollar-sign';
      if (/call|phone|contact/.test(t)) return 'fas fa-phone';
      if (/noise|quiet/.test(t)) return 'fas fa-volume-mute';
      return 'fas fa-exclamation-circle';
    },
async  servicetype (){
    // Shared with the list-view hover preview so both honour the same config;
    // the helper caches the request for the session and yields {} on failure.
    // Don't call setFieldVisibilityForView here, call after service is loaded.
    this.servicetypes2Map = await loadServiceTypesMap();
},
    async getShareUrl() {
      // Try to get canonical share URL for this post
      let url = WEB_ORIGIN + "/view-post/";
      if (this.service && this.service.servicesID) {
        try {
          const res = await axios.post("/api/serviceslinklist", { serviceID: this.service.servicesID });
          if (res.data && res.data.items && res.data.items[0] && res.data.items[0].url) {
            url += res.data.items[0].url;
          } else {
            url += canonicalSlug(this.service.servicesName);
          }
        } catch (e) {
          url += canonicalSlug(this.service.servicesName);
        }
      } else {
        url = window.location.href;
      }
      return url;
    },
    async copyLink() {
      try {
        const url = await this.getShareUrl();
        await navigator.clipboard.writeText(url);
        trackEvent('share_post', { method: 'copy_link', post_id: this.servicesID });
        toast.success("Link copied to clipboard!");
      } catch {
        toast.error("Failed to copy link");
      }
    },
    async shareWhatsApp() {
      const url = await this.getShareUrl();
      window.open(`https://wa.me/?text=${encodeURIComponent(url)}`, "_blank");
    },
    async shareTwitter() {
      const url = await this.getShareUrl();
      window.open(`https://twitter.com/intent/tweet?url=${encodeURIComponent(url)}`, "_blank");
    },
    async shareFacebook() {
      const url = await this.getShareUrl();
      window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`, "_blank");
    },
    async shareEmail() {
      const url = await this.getShareUrl();
      window.location.href = `mailto:?subject=Check this out&body=${encodeURIComponent(url)}`;
    },
    shareInstagram() {
      // Open the specified Instagram page directly
      window.open("https://www.instagram.com/renants_classifieds/", "_blank");
    },

    async trackVisitor() {
      const parser = new UAParser();
      const browserInfo = parser.getResult();

  const visitData = {
    timestamp: new Date().toISOString(),
    browser: browserInfo.browser.name,
    browserVersion: browserInfo.browser.version,
    os: browserInfo.os.name,
    osVersion: browserInfo.os.version,
    device: browserInfo.device.type || "Desktop",
    pageName: "View Ads",
    // Carry the listing identity so the admin "Unauthenticated Users" tab can
    // link each "View Ads" page-view back to the actual listing. serviceName is
    // the route slug used by /view-post/:serviceName.
    serviceSlug: this.serviceName || null,
    servicesID: this.servicesID || null,
    screenResolution: `${window.screen.width}x${window.screen.height}`,
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
  };

      try {
        const response = await fetch("https://api64.ipify.org?format=json");
        const { ip } = await response.json();
        visitData.ip = ip;
        console.log(visitData);
        console.log(visitData.ip);
        axios
          .post("/api/addviewsinfo", {
            ip: visitData.ip,
            timestamp: visitData.timestamp,
            servicesID: this.servicesID,
            userID: this.userID,
            viewerType: "Guest",
            pageName: "View Ads",
            browser: visitData.browser,
            browserVersion: visitData.browserVersion,
            os: visitData.os,
            osVersion: visitData.osVersion,
            device: visitData.device,
            screenResolution: visitData.screenResolution,
            timezone: visitData.timezone,
          })
          .then((response) => {
            console.log("viewsinfo", response);
          });
        await fetch("/api/visitors", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(visitData),
        });
      } catch (error) {
        console.error("Error tracking visitor:", error);
      }
    },

    goBack() {
      const from = this.from;
      if (from === "myads") {
        this.$router.push("/my-adds");
      } else if (from === "favorites") {
        this.$router.push("/favorites");
      } else if (window.history.state && window.history.state.back) {
        // Return to the actual previous page (e.g. /jobs, a citywise page, or
        // the dashboard) so its results, filters and scroll position reappear.
        // Forcing $router.push("/") instead dropped the user's category/search.
        this.$router.back();
      } else {
        // Detail page opened via a direct link / new tab — no history to pop.
        this.$router.push("/");
      }
    },
       setFieldVisibilityForView() {
      this.fieldVisibility = buildFieldVisibility(
        this.servicetypes2Map,
        this.service.serviceType1,
        this.service.serviceType2
      );
    },
    shouldShowField(field) {
      return isFieldVisible(this.fieldVisibility, field);
    },

    openLightbox(index) {
      this.lightboxIndex = index;
      document.body.style.overflowY = "hidden";
    },
    closeLightbox() {
      this.lightboxIndex = null;
      document.body.style.overflowY = "auto";
    },
    prevImage() {
      if (!this.uploadedimages.length) return;
      this.lightboxIndex =
        (this.lightboxIndex - 1 + this.uploadedimages.length) %
        this.uploadedimages.length;
    },
    nextImage() {
      if (!this.uploadedimages.length) return;
      this.lightboxIndex =
        (this.lightboxIndex + 1) % this.uploadedimages.length;
    },
    onTouchStart(e) {
      const t = e.touches[0];
      this.touchStartX = t.clientX;
      this.touchStartY = t.clientY;
    },
    onTouchEnd(e) {
      const t = e.changedTouches[0];
      const dx = t.clientX - this.touchStartX;
      const dy = t.clientY - this.touchStartY;
      if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) {
        if (dx < 0) this.nextImage();
        else this.prevImage();
      }
    },
    onLightboxKeydown(e) {
      if (this.lightboxIndex === null) return;
      if (e.key === "ArrowRight") this.nextImage();
      else if (e.key === "ArrowLeft") this.prevImage();
      else if (e.key === "Escape") this.closeLightbox();
    },
    formatDate(dateString) {
      if (!dateString) return "Invalid Date";
      const date = new Date(dateString);
      return isNaN(date.getTime())
        ? "Invalid Date"
        : date.toLocaleString([], {
            year: "numeric",
            month: "short",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
          });
    },
    // shareWhatsApp() {
    //   window.open(
    //     `https://wa.me/?text=${encodeURIComponent(this.shareUrl)}`,
    //     "_blank",
    //   );
    // },
    // shareTwitter() {
    //   window.open(
    //     `https://twitter.com/intent/tweet?url=${encodeURIComponent(
    //       this.shareUrl,
    //     )}`,
    //     "_blank",
    //   );
    // },
    // shareFacebook() {
    //   window.open(
    //     `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
    //       this.shareUrl,
    //     )}`,
    //     "_blank",
    //   );
    // },
    // shareEmail() {
    //   window.location.href = `mailto:?subject=Check this out&body=${encodeURIComponent(
    //     this.shareUrl,
    //   )}`;
    // },
  },
};
</script>
<style>
html,
body {
  height: 100%;
  margin: 0;
  padding: 0;
}
/* Placeholder frame shown while the slug lookup is in flight, so the listing
   markup never renders against an empty service object. */
.post-loading {
  /* The root .navbar is a Bootstrap flex row, so this must claim the whole
     line — without it the box shrinks to the spinner and pins hard left,
     making justify-content below a no-op. */
  flex: 1 0 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 60vh;
}
.navbar {
  width: 100%;
}

.main-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 24px 16px 0;
  /* gap: 24px; */
  max-width: 1440px;
  margin: 0 auto;
  box-sizing: border-box;
  flex: 1;
  width: 100%;
}

.container-body {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 16px 0px 0px;
  gap: 16px;
  width: 100%;
  max-width: 1208px;
  /* height: 738.71px; */
  height: auto;
}
.left-container {
  /* Frame 59 */

  /* Auto layout */
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 32px;
  width: 100%;
  max-width: 817px;
  /* height: 722.71px; */
  height: auto;
}
.top-section {
  /* Frame 49 */

  /* Auto layout */
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 0px;
  gap: 8px;
  width: 100%;
  max-width: 817px;
  /* height: 114px; */
  height: auto;
  min-height: 114px;
}

.top-section-body {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 32px;
  width: 100%;
  max-width: 817px;
  height: auto;
}

.header-text {
  width: 100%;
  font-family: "Inter", sans-serif;
  font-weight: 600;
  font-size: 38px;
  line-height: 1.2;
  color: #181d27;
  margin-bottom: 8px;
  display: block;
}
.description-view {
  width: 100%;
  height: auto;
}

.additional-content {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
  width: 100%;
  height: auto;
  margin-bottom: 08px;
}

.eye {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  width: auto;
  height: auto;
}

.eye-text {
  font-family: "Inter";
  font-weight: 600;
  font-size: 14px;
  line-height: 17px;
  color: #535862;
  padding: 0;
}
.location {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  width: auto;
  height: auto;
}

.locImage {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 24px;
  height: 24px;
  background: #e6ecfa;
  border-radius: 50%;
  padding: 4px;
}

.location-data {
  font-family: "Inter";
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 17px;
  color: #535862;
  margin: 0;
  padding: 0;
  display: flex;
  align-items: center;
}
.desc-contents {
  margin: 8px 0 0 0;
  padding: 0;
  display: block;
  /* The description is shown exactly as its author wrote it, so the source
     line breaks and blank lines have to survive: pre-line keeps them while
     still wrapping long lines and collapsing runs of spaces. */
  white-space: pre-line;
  overflow-wrap: anywhere;
  font-family: "Inter", sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 28px;

  /* Gray/900 */
  color: #181d27;
}

/* ═══════════════════════════════════════════
   Description Section
═══════════════════════════════════════════ */
.desc-section {
  width: 100%;
  max-width: 817px;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

/* ═══════════════════════════════════════════
   Movie listing (Events → Movies)
═══════════════════════════════════════════ */
.movie-detail {
  display: flex;
  flex-direction: column;
  gap: 18px;
  font-family: "Inter", sans-serif;
}
.movie-synopsis {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.movie-synopsis p {
  margin: 0;
  font-size: 16px;
  line-height: 26px;
  color: #1c2540;
}
.movie-note {
  margin: 0;
  display: flex;
  align-items: flex-start;
  gap: 8px;
  font-size: 13px;
  line-height: 20px;
  color: #92660a;
  background: #fff7e6;
  border: 1px solid #ffe4a3;
  border-radius: 10px;
  padding: 10px 12px;
}
.movie-note i {
  margin-top: 2px;
  color: #d99312;
}

/* Venue / location card */
.movie-venue {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  background: #f4f7ff;
  border: 1px solid #e0e8fb;
  border-radius: 12px;
  padding: 14px 16px;
}
.movie-venue > i {
  font-size: 18px;
  color: #3467d5;
  margin-top: 2px;
}
.movie-venue-text {
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.movie-venue-text strong {
  font-size: 15px;
  font-weight: 600;
  color: #1c2540;
}
.movie-venue-text span {
  font-size: 14px;
  color: #5a6478;
}

/* Each theatre: name card + its own showtimes table */
.movie-venue-block {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

/* Show timings */
.movie-showtimes-title {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: #1c2540;
}
.movie-showtimes-title i {
  color: #3467d5;
}
.movie-showtable {
  border: 1px solid #e7eaf0;
  border-radius: 12px;
  overflow: hidden;
}
.movie-showrow {
  display: grid;
  grid-template-columns: 130px 1fr;
  gap: 12px;
  align-items: center;
  padding: 12px 16px;
  border-bottom: 1px solid #eef1f6;
}
.movie-showrow:nth-child(odd) {
  background: #fafbfe;
}
.movie-showrow:last-child {
  border-bottom: none;
}
.movie-showdate {
  font-size: 14px;
  font-weight: 600;
  color: #1c2540;
}
.movie-showchips {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.movie-chip {
  display: inline-flex;
  align-items: center;
  padding: 5px 12px;
  border-radius: 999px;
  font-size: 13px;
  font-weight: 600;
  color: #1f3987;
  background: #eaf0ff;
  border: 1px solid #d4e0ff;
}
.movie-chip--tba {
  color: #6c7793;
  background: #f1f3f8;
  border-color: #e2e6ee;
  font-weight: 500;
}

@media (max-width: 560px) {
  .movie-showrow {
    grid-template-columns: 1fr;
    gap: 6px;
  }
}

/* Header: icon + "Description" + blue underline */
.desc-section-header {
  display: flex;
  align-items: center;
  gap: 10px;
}

.desc-section-header i {
  font-size: 20px;
  color: #3467d5;
}

.desc-section-title {
  font-family: "Inter", sans-serif;
  font-size: 22px;
  font-weight: 700;
  color: #181d27;
  margin: 0;
}

.desc-section-underline {
  height: 3px;
  width: 48px;
  background: #3467d5;
  border-radius: 2px;
  margin-top: -12px;
  margin-left: 30px;
}

/* Title sub-card */
.desc-title-card {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 4px 0;
}

.desc-title-icon {
  width: 48px;
  height: 48px;
  flex-shrink: 0;
  background: #e6ecfa;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #3467d5;
  font-size: 20px;
}

.desc-title-name {
  font-family: "Inter", sans-serif;
  font-size: 18px;
  font-weight: 700;
  color: #181d27;
  margin: 0 0 2px;
}

.desc-title-sub {
  font-family: "Inter", sans-serif;
  font-size: 13px;
  font-weight: 400;
  color: #717680;
  margin: 0;
}

/* Bullet highlights box */
.desc-bullets-box {
  background: #f5f7ff;
  border-radius: 10px;
  padding: 8px 16px;
  display: flex;
  flex-direction: column;
  gap: 0;
}

.desc-bullet-row {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 10px 0;
  border-bottom: 1px solid #e6ecfa;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  color: #181d27;
  line-height: 1.5;
}

.desc-bullet-row:last-child {
  border-bottom: none;
}

.desc-bullet-icon {
  width: 36px;
  height: 36px;
  flex-shrink: 0;
  background: #3467d5;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 14px;
}

/* Property grid v2: 4 col, icon centered above value */
.prop-grid-v2 {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 12px;
}

.prop-cell-v2 {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 18px 10px 14px;
  border: 1px solid #e6ecfa;
  border-radius: 10px;
  background: #fff;
  gap: 6px;
}

.prop-cell-v2-icon {
  font-size: 26px;
  color: #3467d5;
  margin-bottom: 2px;
}

.prop-cell-v2-value {
  font-family: "Inter", sans-serif;
  font-size: 13px;
  font-weight: 700;
  color: #181d27;
  line-height: 1.3;
}

.prop-cell-v2-label {
  font-family: "Inter", sans-serif;
  font-size: 11px;
  font-weight: 400;
  color: #717680;
  line-height: 1.3;
}

/* Rules / restrictions section: pink bg */
.rules-section {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 0;
  background: #fff5f5;
  border: 1px solid #ffd6d6;
  border-radius: 10px;
  overflow: hidden;
  padding: 20px 16px;
}

.rules-cell {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
  padding: 4px 8px;
  text-align: center;
}

.rules-icon-circle {
  width: 44px;
  height: 44px;
  background: #fff;
  border: 2px solid #e85555;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #e85555;
  font-size: 18px;
  flex-shrink: 0;
}

.rules-label {
  font-family: "Inter", sans-serif;
  font-size: 12px;
  font-weight: 600;
  color: #c0392b;
  line-height: 1.4;
}

/* Responsive */
@media (max-width: 700px) {
  .prop-grid-v2 {
    grid-template-columns: repeat(2, 1fr);
  }
  .rules-section {
    grid-template-columns: repeat(2, 1fr);
    gap: 16px;
  }
}

@media (max-width: 480px) {
  .prop-grid-v2,
  .rules-section {
    grid-template-columns: repeat(2, 1fr);
  }
}

.location-data p {
  margin: 0;
}
.top-right {
  display: flex;
  width: auto;
  align-items: flex-start;
  gap: 8px;
  width: 186px;
  height: 44.31px;
}

.button-width {
  flex-shrink: 0;
  border-radius: 2px;
  border: 0.77px solid transparent;
  background: linear-gradient(white, white) padding-box,
    linear-gradient(90deg, #e33629, #017dca) border-box;
  /* margin-right: 16px; */
  height: 28.3px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  max-width: auto;
}
.button-width p {
  font-family: "Inter", sans-serif;
  font-weight: 600;
  font-size: 13px;
  line-height: 18px;
  /* padding: 3.5px 10.77px; */
  margin: 0;
  border-radius: 4px;
  background-clip: text;
  -webkit-background-clip: text;
  color: transparent;
  -webkit-text-fill-color: transparent;
  background-image: linear-gradient(90deg, #e33629, #017dca);
  white-space: nowrap;
  /* overflow: hidden; */
  text-overflow: ellipsis;
}
.right-button {
  display: flex;
  justify-content: flex-start;
  padding: 0px;
  gap: 16px;
  margin-top: 10px;
  width: 210px;
  height: 38.31px;
}

.share-view {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 4px;
  gap: 8px;

  width: 24px;
  height: 24px;

  background: #ffffff;
  border-radius: 128px;

  margin: 0;
  cursor: pointer;
}

.box-view-body {
  /* Row */

  /* Auto layout */
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 0px;

  width: 817px;
  height: 70.71px;
}
.first-box {
  display: flex;
  flex-direction: column;
  justify-content: center; /* vertically centers main content + subtext */
  align-items: center; /* horizontally centers all content */
  padding: 8px; /* padding inside box */
  gap: 8px; /* space between main text and subtext */

  width: 408px; /* box width */
  height: 70.71px;
  background: #ffffff;
  border: 1px solid #e6ecfa;
  box-sizing: border-box; /* ensures padding + border don't overflow */
}

.first-content p {
  font-family: "Inter";
  font-weight: 600;
  font-size: 20px;
  line-height: 34px;
  text-align: center;
  color: #3467d5;
  margin: 0; /* remove default margin */
}

.first-subtext p {
  font-family: "Inter";
  font-weight: 500;
  font-size: 9px;
  line-height: 13px;
  color: #181d27;
  text-align: center;
  margin: 0;
}
.second-box {
  display: flex;
  flex-direction: column;
  justify-content: center; /* vertical centering */
  align-items: center; /* horizontal centering */
  padding: 8px; /* internal padding */
  gap: 8px; /* space between number and subtext */

  width: 136px;
  height: 70.71px;

  border: 1px solid #e6ecfa;
  box-sizing: border-box; /* include padding & border in width */
}

.second-content p {
  font-family: "Inter";
  font-weight: 600;
  font-size: 28.57px;
  line-height: 34px;
  text-align: center;
  margin: 0; /* remove default margin */
}

.second-subtext p {
  font-family: "Inter";
  font-weight: 500;
  font-size: 9px;
  gap: 5px;
  line-height: 13px;
  color: #181d27;
  text-align: center;
  margin: 0;
}
.third-box {
  display: flex;
  flex-direction: column;
  justify-content: center; /* vertical centering */
  align-items: center; /* horizontal centering */
  padding: 8px;
  gap: 4px; /* smaller gap to fit inside box */

  width: 136px;
  height: 70.71px;

  border: 1px solid #e6ecfa;
  box-sizing: border-box;
}

.third-content {
  display: flex;
  flex-direction: column;
  align-items: center; /* horizontally center content */
  justify-content: center; /* vertically center content if needed */
  gap: 2px; /* small gap between number and subtext */
  width: 100%;
}

.third-content p {
  font-family: "Inter";
  font-weight: 600;
  font-size: 28.57px;
  line-height: 34px;
  text-align: center;
  color: #292929;
  margin: 0;
}

.third-subtext p {
  font-family: "Inter";
  font-weight: 500;
  font-size: 9px; /* slightly increased from 8.57px for better readability */
  line-height: 13px;
  text-align: center;
  color: #181d27;
  margin: 0;
}
.fourth-box {
  display: flex;
  flex-direction: column;
  justify-content: center; /* vertical centering */
  align-items: center; /* horizontal centering */
  padding: 8px;
  gap: 4px; /* small gap between number and subtext */

  width: 136px;
  height: 70.71px;

  border: 1px solid #e6ecfa;
  box-sizing: border-box;
}

.fourth-content {
  display: flex;
  flex-direction: column;
  align-items: center; /* horizontally center content */
  justify-content: center;
  gap: 2px; /* space between number and subtext */
  width: 100%;
}

.fourth-content p {
  font-family: "Inter";
  font-weight: 600;
  font-size: 28.57px;
  line-height: 34px;
  text-align: center;
  color: #292929;
  margin: 0;
}

.fourth-subtext p {
  font-family: "Inter";
  font-weight: 500;
  font-size: 9px;
  line-height: 13px;
  text-align: center;
  color: #181d27;
  margin: 0;
}

.images-box {
  /* Frame 54 */

  /* Auto layout */
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 10px;

  width: 817px;
  /* height: 474px; */
  height: auto !important;
}
.image-header {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;
  width: 817px;
  height: 38px;
  border-bottom: 1px solid #e6ecfa;
}

.image-header p {
  font-family: "Inter";
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  margin: 0;
  cursor: pointer;

  color: #717680; /* default gray for inactive tabs */
}

.image-header p.active {
  color: #3467d5; /* blue for active tab */
}

.images-section {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
  padding: 0 8px;
  z-index: 1;
  width: 100%;
  max-width: 817px;
  border-radius: 6px;
}

.addImages {
  box-sizing: border-box;
  display: block;
  width: 100%;
  aspect-ratio: 4 / 3;
  overflow: hidden;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  cursor: pointer;
  transition: opacity 0.2s;
}
.addImages:hover {
  opacity: 0.85;
}
.addImages img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 8px;
  display: block;
}

.show-more-images {
  display: flex;
  justify-content: center;
  align-self: stretch;
  width: 100%;
  max-width: 817px;
  margin-top: 16px;
}
.show-more-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 20px;
  font-size: 14px;
  font-weight: 600;
  color: #017dca;
  background: #fff;
  border: 1px solid #017dca;
  border-radius: 24px;
  cursor: pointer;
  transition: background 0.2s, color 0.2s;
}
.show-more-btn:hover {
  background: #017dca;
  color: #fff;
}

.lightbox {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 2147483647;
  cursor: zoom-out;
  touch-action: pan-y;
}

.lightbox-content img {
  max-width: 90vw;
  max-height: 90vh;
  border-radius: 8px;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.5);
}
.close-btn-image {
  position: absolute;
  /* Full-screen lightbox — keep the only exit below the notch/status bar */
  top: calc(16px + env(safe-area-inset-top, 0px));
  right: 16px;
  background: rgba(255, 255, 255, 0.9);
  color: #1e1d1d;
  border: none;
  border-radius: 50%;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  font-weight: 700;
  cursor: pointer;
  z-index: 10000;
}
.lightbox-nav {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background: rgba(255, 255, 255, 0.9);
  color: #1e1d1d;
  border: none;
  border-radius: 50%;
  width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  cursor: pointer;
  z-index: 10000;
  user-select: none;
}
.lightbox-nav:hover {
  background: #fff;
}
.lightbox-prev {
  left: 16px;
}
.lightbox-next {
  right: 16px;
}
.lightbox-counter {
  position: absolute;
  bottom: 16px;
  left: 50%;
  transform: translateX(-50%);
  color: #fff;
  background: rgba(0, 0, 0, 0.5);
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 14px;
  z-index: 10000;
}
@media (max-width: 600px) {
  .lightbox-nav {
    width: 38px;
    height: 38px;
    font-size: 16px;
  }
  .lightbox-prev {
    left: 8px;
  }
  .lightbox-next {
    right: 8px;
  }
}

.content-wrapper {
  width: 100%;
  max-width: 1208px;
  margin: 0 auto;
}

.back-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  background: #ffffff;
  border: 1px solid #d1d5db;
  border-radius: 8px;

  font-size: 16px;
  font-weight: 500;
  color: #374151;

  cursor: pointer;
}

.back-btn img {
  width: 18px;
  height: 18px;
}

@media (max-width: 600px) {
  /* Global layout */
  .main-container {
    padding: 16px;
  }

  .container-body {
    flex-direction: column;
    width: 100%;
    height: auto;
    gap: 24px;
  }
  .login-container {
    max-width: 100% !important;
    width: 100% !important;
  }

  .login-container * {
    max-width: 100% !important;
  }
  .left-container {
    width: 100%;
    max-width: 100%;
    height: auto;
    gap: 24px;
  }

  .top-section {
    flex-direction: column;
    width: 100%;
    height: auto;
    gap: 16px;
  }

  .top-section-body {
    width: 100%;
    max-width: 100%;
  }

  /* Title */
  .header-text {
    font-size: 26px;
    line-height: 32px;
  }

  /* Extra info row */
  .additional-content {
    flex-wrap: wrap;
    gap: 12px;
  }

  /* LOCATION */
  .location {
    width: 100%;
  }

  /* Right buttons (Service type / Share) */
  .top-right {
    width: 100%;
    justify-content: flex-start;
  }

  .right-button {
    width: 100%;
  }

  .button-width {
    max-width: 120px;
    overflow: hidden;
  }

  .box-view-body {
    /* flex-wrap: wrap;
    width: 100%;
    height: auto;
    gap: 10px; */
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap; /* all boxes in one row */
    width: 100%;
    overflow: hidden; /* prevent swipe */
  }

  .first-box {
    flex: 1 1 auto; /* grow to take remaining width */
    min-width: 0; /* allow shrinking */
  }

  .second-box,
  .third-box,
  .fourth-box {
    flex: 0 0 auto;
    width: 60px;
  }

  .first-content p {
    font-size: 16px; /* scale text for mobile */
    line-height: 20px;
  }

  .first-subtext p,
  .second-subtext p,
  .third-subtext p,
  .fourth-subtext p {
    font-size: 09px;
  }

  /* IMAGES SECTION */
  .images-box {
    width: 100%;
    height: auto;
    gap: 8px;
  }

  .image-header {
    width: 100%;
    gap: 12px;
  }

  .images-section {
    grid-template-columns: 1fr;
    width: 100%;
    padding: 0;
  }

  .addImages {
    width: 100%;
    aspect-ratio: 4 / 3;
  }

  .addImages img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .top-section-body > * {
    width: 100%;
  }

  .container-body {
    flex-direction: column !important;
    width: 100% !important;
  }

  .container-body > * {
    width: 100% !important;
    max-width: 100% !important;
  }
}

.share-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.55);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.share-box {
  position: relative; /* needed for close button positioning */
  background: #fff;
  padding: 25px;
  width: 340px;
  border-radius: 18px;
  box-shadow: 0 5px 25px rgba(0, 0, 0, 0.15);
  animation: popupShow 0.25s ease;
}

@keyframes popupShow {
  from {
    opacity: 0;
    transform: scale(0.9);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

.share-box h3 {
  margin-bottom: 15px;
  font-size: 20px;
  font-weight: 600;
  text-align: center;
}

.share-options {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.share-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px;
  border: 1px solid #ddd;
  border-radius: 10px;
  cursor: pointer;
  transition: 0.2s;
}

.share-item:hover {
  background: #f5f5f5;
  transform: translateY(-2px);
}

.share-item img {
  width: 26px;
  height: 26px;
}

.close-btn {
  position: absolute;

  right: 05px;
  width: 32px;
  height: 32px;
  padding: 0;
  color: black;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  font-size: 20px;
  line-height: 32px;
  text-align: center;
  z-index: 10; /* ensure it’s above other content */
}

.share-item i {
  font-size: 24px;
  margin-right: 8px;
  color: #333;
}

.share-item span {
  font-family: "Inter";
  font-weight: 500;
  font-size: 14px;
  text-align: center;
  color: #181d27;
}

@media (min-width: 600px) and (max-width: 1200px) {
  /* Main 2-column container */
  .container-body {
    flex-direction: column;
    width: 100%;
    max-width: 100%;
    gap: 24px;
  }

  /* LEFT COLUMN — Full Width */
  .left-container {
    width: 100%;
    max-width: 100%;
  }

  /* Top section fully expands */
  .top-section,
  .top-section-body {
    width: 100%;
    max-width: 100%;
  }

  .header-text {
    font-size: 32px;
    line-height: 38px;
  }

  /* Meta items (date, views) wrap cleanly */
  .additional-content {
    flex-wrap: wrap;
    gap: 12px;
    width: 100%;
  }

  /* Service type + share buttons */
  .top-right {
    width: 100%;
    justify-content: flex-start;
  }

  .right-button {
    width: 100%;
  }

  /* Stats boxes row */
  .box-view-body {
    width: 100%;
    flex-wrap: wrap;
    gap: 12px;
    height: auto;
  }

  .first-box {
    width: 100%;
  }

  .second-box,
  .third-box,
  .fourth-box {
    width: calc(33.33% - 8px);
  }

  /* Images section full width */
  .images-box,
  .image-header,
  .images-section {
    width: 100%;
    max-width: 100%;
  }

  .addImages {
    width: 100%;
    aspect-ratio: 4 / 3;
  }

  /* Description full width */
  .description-view {
    width: 100%;
  }

  /* Share Modal */
  .share-box {
    width: 90%;
    max-width: 380px;
  }

  .container-body > *:last-child {
    width: 100%;
    max-width: 100%;
  }

}
</style>
